import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useNewFinishAptitudeTestMutation } from '../../NewAptitudeQuizSlice';
import { useNavigate } from 'react-router-dom';
import useNewAptitudeTestResponsesContext from 'hooks/useNewAptitudeTestResponseContext';
import htmlparser from 'html-react-parser';


const NewShowQuestion: React.FC = () => {
  const { state, dispatch } = useNewAptitudeTestResponsesContext();
  const questionToShow =
    state.responses[state.currentCategoryNo].questions[state.currentQuestion];
  // changed this: useNewFinishAptitudeTestMutation , according to new aptitude slice
  const [finishAptitudeTest] = useNewFinishAptitudeTestMutation();

  const navigate = useNavigate();

  //useEffect to keep tab switch count
  useEffect(() => {
    function handleVisibilityChange() {
      if (document.hidden) {
        dispatch({
          type: 'UPDATE_TAB_SWITCHED_COUNT',
          payload: state.tabSwitchedCount + 1,
        });
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [dispatch, state.tabSwitchedCount]);

  function finishTest() {
    finishAptitudeTest({})
      .unwrap()
      .then((res: any) => {
        navigate('/quiz/new-aptitude/scorecard');
      });
  }
  return (
    <div className='select-none'>
      <p className='font-semibold p-4 text-justify flex'>
        <p className='text-secondary'>{state.currentQuestion + 1}. </p>{' '}
        <p> {htmlparser(questionToShow.question)}</p>
      </p>
      <div className='grid grid-flow-col auto-cols-fr gap-4'>
        {questionToShow.image?.map((imageName: any) => {
          return (
            <img
              key={imageName}
              className='rounded shadow h-full'
              src={imageName}
              alt='Question'
            />
          );
        })}
      </div>
      {questionToShow.responseType === 'text' ? (
        <input
          type='text'
          placeholder='Your Answer'
          className='p-2 m-2 rounded w-full md:w-3/4'
          value={questionToShow.userInput}
          onChange={(e) =>
            dispatch({
              type: 'UPDATE_INPUT',
              payload: { value: e.target.value },
            })
          }
        />
      ) : (
        questionToShow.options.map((option: any) => {
          return (
            <div
              onClick={() => {
                dispatch({
                  type: 'UPDATE_OPTIONS',
                  payload: {
                    option: option._id,
                    value: !option.selected,
                    maxSelect: questionToShow.maxSelect,
                  },
                });
              }}
              className={classNames(
                'm-4 rounded py-2 px-4',
                {
                  'bg-secondary': option.selected,
                },
                {
                  'bg-gray-100': !option.selected,
                }
              )}
              key={option._id}>
              {htmlparser(option.option)}
            </div>
          );
        })
      )}
      <div className='flex justify-between mx-4 mt-6 text-primary font-semibold'>
        <div>
          <button
            onClick={() => {
              dispatch({
                type: 'UPDATE_CURRENT_QUESTION',
                payload: state.currentQuestion - 1,
              });
            }}
            className={classNames('text-secondary font-semibold', {
              hidden: !state.currentQuestion,
            })}>
            Previous
          </button>
        </div>

        <button
          onClick={() => {
            dispatch({
              type: 'UPDATE_CURRENT_QUESTION',
              payload: state.currentQuestion + 1,
            });
          }}
          className={classNames(
            'border border-gray-400 px-8 py-1 rounded-xl shadow bg-white',
            { hidden: state.currentQuestion + 1 === state.totalQuestions }
          )}>
          Next
        </button>

        {state.currentQuestion + 1 === state.totalQuestions && (
          <button
            onClick={() => {
              dispatch({
                type: 'UPDATE_CATEGORY',
                //payload: state.currentQuestion + 1,
              });
            }}
            className={classNames(
              'border border-gray-400 px-8 py-1 rounded-xl shadow bg-white',
              { hidden: state.currentCategoryNo === 3 }
            )}>
            Next Section
          </button>
        )}

        {state.currentCategoryNo === 3 &&
          state.currentQuestion + 1 === state.totalQuestions && (
            <button
              onClick={() => finishTest()}
              className={classNames(
                'border border-gray-400 px-8 py-1 rounded-xl shadow bg-white'
              )}>
              Finish Test
            </button>
          )}
      </div>
    </div>
  );
};

export default NewShowQuestion;
